import React, { useState } from "react";
import queryString from "query-string";
import { CardHeader, CardBody } from "reactstrap";
import { useEffectOnce } from "hooks";

import { accountService, alertService } from "services";

const EmailStatus = {
  Deleting: "Deleting",
  Failed: "Failed",
};

const DeleteEmail = ({ history }) => {
  const [emailStatus, setEmailStatus] = useState(EmailStatus.Deleting);

  useEffectOnce(() => {
    const { email, token } = queryString.parse(history.location.search);

    // remove token from url to prevent http referer leakage
    history.replace(history.location.pathname);

    accountService
      .deleteEmail(email, token)
      .then(() => {
        alertService.success("Your Email has been deleted from our Database", {
          keepAfterRouteChange: true,
        });
        history.push("/");
      })
      .catch((e) => {
        alertService.success(e, {
          keepAfterRouteChange: true,
        });
        setEmailStatus(EmailStatus.Failed);
      });
  });

  function getBody() {
    switch (emailStatus) {
      case EmailStatus.Deleting:
        return <div>Deleting...</div>;
      case EmailStatus.Failed:
        return <div>Deleting failed, please contact the site admin.</div>;
      default:
        throw new Error("Not implemented");
    }
  }

  return (
    <>
      <CardHeader tag="h3">Delete Email</CardHeader>
      <CardBody>{getBody()}</CardBody>
    </>
  );
};

export { DeleteEmail };
